import type { PlanTierId } from '@super/shared-types'

// Soft, low-saturation per-tier tints. Full class literals so Tailwind's
// content scanner picks them up when the tier is looked up at runtime.
export const TIER_SELECTED_CLASSES: Record<PlanTierId, string> = {
  starter:
    'bg-emerald-50 border-emerald-300 ring-emerald-200 dark:bg-emerald-950/30 dark:border-emerald-800',
  growth:
    'bg-sky-50 border-sky-300 ring-sky-200 dark:bg-sky-950/30 dark:border-sky-800',
  scale:
    'bg-violet-50 border-violet-300 ring-violet-200 dark:bg-violet-950/30 dark:border-violet-800',
  pro: 'bg-amber-50 border-amber-300 ring-amber-200 dark:bg-amber-950/30 dark:border-amber-800',
  enterprise:
    'bg-slate-100 border-slate-400 ring-slate-300 dark:bg-slate-900/50 dark:border-slate-700',
}

// Gradient tint used on plan hero surfaces (e.g. Settings > Billing current
// plan card). Mirrors the LinkedIn share hero on the onboarding recap.
export const TIER_GRADIENT_CLASSES: Record<PlanTierId, string> = {
  starter:
    'bg-gradient-to-br from-emerald-500/40 via-slate-200/20 to-slate-300/30 dark:from-emerald-400/40 dark:via-slate-800/40 dark:to-slate-800/50',
  growth:
    'bg-gradient-to-br from-sky-500/40 via-slate-200/20 to-slate-300/30 dark:from-sky-400/40 dark:via-slate-800/40 dark:to-slate-800/50',
  scale:
    'bg-gradient-to-br from-violet-500/40 via-slate-200/20 to-slate-300/30 dark:from-violet-400/40 dark:via-slate-800/40 dark:to-slate-800/50',
  pro: 'bg-gradient-to-br from-amber-500/40 via-slate-200/20 to-slate-300/30 dark:from-amber-400/40 dark:via-slate-800/40 dark:to-slate-800/50',
  enterprise:
    'bg-gradient-to-br from-slate-500/40 via-slate-200/20 to-slate-300/30 dark:from-slate-400/40 dark:via-slate-800/40 dark:to-slate-800/50',
}
